const SELECTORS = {
    WRAPPER: '.js-due-date',
    FORM: '.js-due-date-calc',
    RESULT_HOLDER: '.js-due-date-result',
    RESULT_DATE: '.js-due-date-result-date',
    RESULT_ZODIAC: '.js-due-date-result-zodiac',
    RESULT_PREGNANT_WEEKS: '.js-due-date-result-weeks',
    RESULT_CONCEPTION_WEEKS: '.js-due-date-result-conception',
    RESET: '.js-due-date-result-reset',
};

const STATE_CLASSES = {
    IS_LOADING: 'is-loading',
    HAS_RESULT: 'due-date-calculator__content__show-result',
    HAS_ERROR: 'due-date-calculator__content__has-error',
    HAS_GIVEN_BIRTH: 'due-date-calculator__content__has-given-birth',
};

const FETCH_CONFIG = {
    method: 'POST',
};

const LOCAL_STORAGE_KEY = 'dueDate';

function initDueDateCalculator() {
    const dueDateCalculator = document.querySelector(SELECTORS.WRAPPER);

    if (dueDateCalculator) {
        const form = dueDateCalculator.querySelector(SELECTORS.FORM);
        const resultHolder = dueDateCalculator.querySelector(SELECTORS.RESULT_HOLDER);

        const resultNodes = {
            birthdate: resultHolder.querySelector(SELECTORS.RESULT_DATE),
            zodiac: resultHolder.querySelector(SELECTORS.RESULT_ZODIAC),
            pregnant_weeks: resultHolder.querySelector(SELECTORS.RESULT_PREGNANT_WEEKS),
            conception_weeks: resultHolder.querySelector(SELECTORS.RESULT_CONCEPTION_WEEKS),
        };

        const reset = dueDateCalculator.querySelector(SELECTORS.RESET);
        const hasPreviousResult = getSavedCalculatedResult() !== null;
        const { action } = form;

        if (hasPreviousResult) {
            const previousResult = getSavedCalculatedResult();
            if (previousResult.conception_weeks > 40) {
                dueDateCalculator.classList.add(STATE_CLASSES.HAS_GIVEN_BIRTH);
            } else {
                dueDateCalculator.classList.add(STATE_CLASSES.HAS_RESULT);
                setResults(resultNodes, previousResult);
            }
        }

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            dueDateCalculator.classList.add(STATE_CLASSES.IS_LOADING);
            const formData = new URLSearchParams();
            const entries = new FormData(form).entries();
            const dataObject = Object.fromEntries(entries);

            Object.entries(dataObject).forEach(([key, value]) => {
                formData.append(key, value);
            });

            FETCH_CONFIG.body = formData;

            fetch(action, FETCH_CONFIG)
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        dueDateCalculator.classList.remove(STATE_CLASSES.HAS_RESULT);
                        dueDateCalculator.classList.remove(STATE_CLASSES.HAS_GIVEN_BIRTH);

                        dueDateCalculator.classList.add(STATE_CLASSES.HAS_ERROR);
                        deleteSavedCalculatedResult();
                    } else if (data.conception_weeks > 40) {
                        dueDateCalculator.classList.remove(STATE_CLASSES.HAS_ERROR);
                        dueDateCalculator.classList.remove(STATE_CLASSES.HAS_RESULT);

                        dueDateCalculator.classList.add(STATE_CLASSES.HAS_GIVEN_BIRTH);
                    } else {
                        dueDateCalculator.classList.remove(STATE_CLASSES.HAS_ERROR);
                        dueDateCalculator.classList.remove(STATE_CLASSES.HAS_GIVEN_BIRTH);

                        dueDateCalculator.classList.add(STATE_CLASSES.HAS_RESULT);
                        setResults(resultNodes, data);
                        saveCalculatedResult(data);
                    }

                    dueDateCalculator.classList.remove(STATE_CLASSES.IS_LOADING);
                })
                .catch((error) => {
                    dueDateCalculator.classList.remove(STATE_CLASSES.IS_LOADING);
                    dueDateCalculator.classList.remove(STATE_CLASSES.HAS_RESULT);
                    dueDateCalculator.classList.add(STATE_CLASSES.HAS_ERROR);
                    deleteSavedCalculatedResult();
                    console.error('Error:', error);
                });
        });

        reset.addEventListener('click', (e) => {
            e.preventDefault();

            deleteSavedCalculatedResult();
            dueDateCalculator.classList.remove(STATE_CLASSES.HAS_RESULT);
            dueDateCalculator.classList.remove(STATE_CLASSES.HAS_ERROR);
            dueDateCalculator.classList.remove(STATE_CLASSES.HAS_GIVEN_BIRTH);
        });
    }
}

function saveCalculatedResult(data) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
}

function deleteSavedCalculatedResult() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
}

function getSavedCalculatedResult() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
}

function setResults(nodes, data) {
    Object.entries(nodes).forEach(([key, value]) => {
        const node = value;
        node.textContent = data ? data[key] : '';
    });
}

export { initDueDateCalculator };
